import { render } from "./Register.vue?vue&type=template&id=35b276ec"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/Register.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35b276ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35b276ec', __exports__)) {
    api.reload('35b276ec', __exports__)
  }
  
  module.hot.accept("./Register.vue?vue&type=template&id=35b276ec", () => {
    api.rerender('35b276ec', render)
  })

}


export default __exports__